module.exports = __webpack_public_path__ + "media/images/gallery/pn_on-881ad6601f650c6fbd4147589b4cac48.gif";